import { logger } from 'src/utils/logger.utils'
import type { JsonApiResponse } from './json-api.types'

export function handleJsonApiError<ReturnType, MetaInfos = unknown>(
  response: Error | JsonApiResponse<ReturnType, MetaInfos>,
  customErrorHandler?: (error: Error) => void,
): ReturnType | undefined {
  if (!(response instanceof Error)) return response.data

  logger.error(response)
  if (customErrorHandler) customErrorHandler(response)

  return
}
